const publicUrl = process.env.PUBLIC_URL || '';

const shopProducts = [
  {
    id: 'white-sourdough',
    categoryId: 'artisan-bread',
    name: 'White sourdough',
    category: 'Artisan bread',
    description: 'A light, naturally leavened loaf with a gentle golden crust.',
    ingredients: 'Wheat flour, water, sourdough starter, salt.',
    price: 5.5,
    image: `${publicUrl}/images/breads/dinkel-bread1.webp`,
  },
  {
    id: 'wholegrain-bread',
    categoryId: 'artisan-bread',
    name: 'Wholegrain bread',
    category: 'Artisan bread',
    description: 'Rich wholegrain flavour, a tender crumb, and a deep baked aroma.',
    ingredients: 'Wholegrain flour, wheat flour, water, sourdough starter, salt.',
    price: 6.5,
    image: `${publicUrl}/images/breads/dinkel3.webp`,
  },
  {
    id: 'golden-grain',
    categoryId: 'artisan-bread',
    name: 'Golden grain',
    category: 'Artisan bread',
    description: 'A hearty loaf with a warm colour, crisp crust, and soft centre.',
    ingredients: 'Wheat flour, golden grain, water, sourdough starter, salt.',
    price: 6,
    image: `${publicUrl}/images/breads/dinkel5.webp`,
  },
  {
    id: 'dinkel-rye',
    categoryId: 'artisan-bread',
    name: 'Dinkel–rye loaf',
    category: 'Artisan bread',
    description: 'A balanced sourdough made with dinkel and rye for a fuller taste.',
    ingredients: 'Dinkel flour, rye flour, water, sourdough starter, salt.',
    price: 6.8,
    image: `${publicUrl}/images/breads/dinkel-bread2.webp`,
  },
  {
    id: 'kozunak',
    categoryId: 'breakfast',
    name: 'Homemade kozunak',
    category: 'Pastry',
    description: 'Soft, fragrant sweet bread for breakfast, gifts, and celebrations.',
    ingredients: 'Wheat flour, eggs, milk, butter, sugar, yeast.',
    price: 8,
    image: `${publicUrl}/images/breads/kozunak4.webp`,
  },
  {
    id: 'pastry-box',
    categoryId: 'breakfast',
    name: 'Morning pastry box',
    category: 'Pastry box',
    description: 'A small selection of fresh pastries made for a slow morning.',
    ingredients: 'Wheat flour, butter, eggs, milk, seasonal fruit.',
    price: 14,
    image: `${publicUrl}/images/desserts/Pastry.webp`,
  },
];

export default shopProducts;
